import { GameServer, GameServerStatus } from 'models';

export const isGameServerFinished = (gameServer: GameServer): boolean =>
  gameServer?.status === GameServerStatus.Finished ||
  Date.now() > gameServer?.season_finish * 1000;
